import { useFetchModulationBalance } from './Contracts/Balance/hooks/useFetchModulationBalance'
import { useFetchModulationLocationEligibleContracts } from './Contracts/Elligible/hooks/useFetchLocationEligibleContracts'
import { useCreateModulationLocationContract } from './ModulationLocationContracts/hooks/useCreateModulationLocationContract'
import { useDeleteModulationLocationContract } from './ModulationLocationContracts/hooks/useDeleteModulationLocationContracts'
import {
  useFetchCurrentModulationLocationContracts,
  useFetchFutureModulationLocationContracts,
  useFetchModulationLocationContract,
  useFetchModulationLocationContracts,
  useFetchPastModulationLocationContracts
} from './ModulationLocationContracts/hooks/useFetchModulationLocationContracts'
import { useUpdateModulationLocationContract } from './ModulationLocationContracts/hooks/useUpdateModulationLocationContracts'
import { useDeleteModulationUserContractOperation } from './ModulationUserContracts/Operations/hooks/useDeleteModulationUserContractOperation'
import {
  useFetchModulationUserContractOperations,
  useFetchModulationUserContractRelativeOperations
} from './ModulationUserContracts/Operations/hooks/useFetchModulationUserContractOperations'
import { useUpdateModulationUserContractOperation } from './ModulationUserContracts/Operations/hooks/useUpdateModulationUserContractOperation'
import { useFetchModulationUserContractReport } from './ModulationUserContracts/Report/hooks/useFetchUserContractReport'
import { modulationContractReportInvalidations } from './ModulationUserContracts/Report/modulation.contract.report.cacheKeys'
import { useCreateModulationUserContract } from './ModulationUserContracts/hooks/useCreateModulationUserContract'
import {
  useFetchCurrentModulationUserContract,
  useFetchFutureModulationUserContracts,
  useFetchModulationUserContracts,
  useFetchPastModulationUserContracts
} from './ModulationUserContracts/hooks/useFetchModulationUserContracts'
import { useFetchModulationPayrollReport } from './Report/hooks/useFetchModulationPayrollReport'

class ModulationService {
  contracts = {
    useFetchAllEligible: useFetchModulationLocationEligibleContracts,
    useFetchBalance: useFetchModulationBalance
  }

  modulationUserContracts = {
    useCreateOne: useCreateModulationUserContract,
    useFetchAll: useFetchModulationUserContracts,
    useFetchPast: useFetchPastModulationUserContracts,
    useFetchCurrent: useFetchCurrentModulationUserContract,
    useFetchFuture: useFetchFutureModulationUserContracts,
    // report
    useFetchReport: useFetchModulationUserContractReport,
    invalidateReport: modulationContractReportInvalidations.invalidateReport,
    // operations
    useFetchAllOperations: useFetchModulationUserContractOperations,
    useFetchRelativeOperations:
      useFetchModulationUserContractRelativeOperations,
    useUpdateOperation: useUpdateModulationUserContractOperation,
    useDeleteOperation: useDeleteModulationUserContractOperation
  }

  modulationLocationContracts = {
    useFetchAll: useFetchModulationLocationContracts,
    useFetchOne: useFetchModulationLocationContract,
    useFetchPast: useFetchPastModulationLocationContracts,
    useFetchCurrent: useFetchCurrentModulationLocationContracts,
    useFetchFuture: useFetchFutureModulationLocationContracts,
    useCreate: useCreateModulationLocationContract,
    useUpdate: useUpdateModulationLocationContract,
    useDelete: useDeleteModulationLocationContract
  }

  modulationReport = {
    useFetchReport: useFetchModulationPayrollReport
  }
}

export const modulationService = new ModulationService()
